export const IssuesIcon = ({ color }: { color?: string }): JSX.Element => {
  const className = 'icon icon--issues-icon';
  color = color || '#BA4E00';

  return (
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...{ className }}
    >
      <path
        d="M12.2789 15H17.2789L15.874 13.5951C15.493 13.2141 15.2789 12.6973 15.2789 12.1585V9C15.2789 6.38757 13.6093 4.16509 11.2789 3.34142V3C11.2789 1.89543 10.3835 1 9.27893 1C8.17436 1 7.27893 1.89543 7.27893 3V3.34142C4.94855 4.16509 3.27893 6.38757 3.27893 9V12.1585C3.27893 12.6973 3.06488 13.2141 2.68386 13.5951L1.27893 15H6.27893M12.2789 15V16C12.2789 17.6569 10.9358 19 9.27893 19C7.62208 19 6.27893 17.6569 6.27893 16V15M12.2789 15H6.27893"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default IssuesIcon;
